import { Components, Theme } from "@mui/material";

export const MuiTableCell: Components<Omit<Theme, "MuiTableCell">>["MuiTableCell"] =
  {
    styleOverrides: {
      root: {
        border: "1px solid #00000014",
        fontSize: 12,
      },
      head: ({ theme: { palette } }) => ({
        fontSize: 12,
        lineHeight: "18px",
        fontWeight: 500,
        color: palette.grey[500],
      }),
    },
  };
